import Antt from '../../../services/antt'
import Auth from '../../../services/auth'

export default {
  props:['vehicle', 'rntrc'],
  data(){
    return {
      serialNumber: undefined,
      driver: {},
      errorMsg: undefined,
      isVinculated: false,
      loading: undefined
    }
  },
  computed:{
    ownFleet: {
      get() {
        return this.vehicle.ownFleet == 'Y';
      },
      set(val){
        this.vehicle.ownFleet = val ? 'Y' : 'N';
      }
    }
  },
  created(){
    if(this.vehicle.drivers && this.vehicle.drivers.driver && this.vehicle.drivers.driver.length > 0){
      this.driver = this.vehicle.drivers.driver[0];
    }
  },
  methods:{

    vinculate(){
      this.errorMsg = undefined;
      this.loading = this.$validator.validateAll().then(s => {

        if(this.vehicle.ownFleet == 'Y'){
          delete this.vehicle.drivers;
          this.vehicle.rntrc = this.rntrc;
        } else {
          this.vehicle.drivers = {driver: [this.driver]};
        }

        return Antt.vincularRntrc({vehicle: this.vehicle, taxpayerIdNumber: Auth.currentUser.taxIdNumber, serialNumber: this.serialNumber}).then(resp => {
          this.isVinculated = true;
        })
      }).catch(err => {
        
        this.errorMsg = err.data.status.message;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/rntrc/vehicle-rntrc.js